export enum EFormLabel {
	MONTHS = 'months',
	DAYS = 'days',
}
